import { appColors, fontSize, appFonts } from '../../appTheme';
import { StyleSheet } from 'react-native';

export const roleStyle = StyleSheet.create({
    container: {
        flex: 1, backgroundColor: appColors.lightBackgroundColor
    },
    searchBarView: {
        flexDirection: "row", marginTop: 10, marginHorizontal: 7
    },
    addRoleButtonStyle: {
        width: 150, height: 50, borderRadius: 7, backgroundColor: appColors.primary, borderWidth: 1, borderColor: appColors.primary, marginLeft: 10
    },
    plusIconView: {
        alignSelf: "flex-end",
        backgroundColor: appColors.primary,
        borderRadius: 50,
        alignItems: "center",
        justifyContent: "center",
        height: 55,
        width: 55,
        position: "absolute",
        bottom: 25,
        right: 25
    },
    activityView: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center'
    },
    cardContainer: {
        backgroundColor: appColors.light, borderRadius: 10, borderWidth: 0,
    },
    mainView: {
        flexDirection: 'row', padding: 0, marginHorizontal: 2, marginVertical: 10
    },
    elementName: {
        fontSize: fontSize.mediumFontSize, fontFamily: appFonts.bold, color: appColors.lightDark, marginBottom: 10
    },
    createdDate: {
        fontSize: fontSize.smallFontSize, fontFamily: appFonts.bold, marginBottom: 10
    },

    descriptionView: {
        flexDirection: 'row'
    },
    activeUserView: {
        justifyContent: 'center',
        alignSelf: 'flex-end',
    },
    activeUserBadge: {
        height: 30, backgroundColor: appColors.lightYellow,
        borderRadius: 8
    },
    activeUserText: {
        fontFamily: appFonts.bold,
        fontSize: fontSize.badgeFontSize, color: appColors.lightDark
    },
    activeUserContainer: {
        justifyContent: 'center',
        alignSelf: 'flex-start',
        marginBottom: 7
    },
    iconMainView: {
        flexDirection: 'row', justifyContent: 'center',
        alignSelf: "flex-end", flex: 0.15,
    },
    itemCard: {
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: appColors.light,
        borderRadius: 10,
        padding: 12,
        flex: 1,
        gap: 8,
    },
    searchContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingHorizontal: 12,
        paddingVertical: 8,
        gap: 8,
    },
});
